import { useEffect, useState } from 'react';
import { Avatar, AvatarFallback, AvatarImage } from './avatar';

export type ProfileAvatarProps = {
  name?: string | null;
  email?: string | null;
  imageUrl?: string | null;
  alt: string;
  size?: number;
  className?: string;
};

const getInitials = (name?: string | null, email?: string | null) => {
  if (name) {
    const initials = name
      .trim()
      .split(/\s+/)
      .filter(Boolean)
      .map((part) => part[0])
      .join('')
      .toUpperCase()
      .slice(0, 2);
    if (initials) return initials;
  }

  return email?.trim()?.[0]?.toUpperCase() ?? 'U';
};

export function ProfileAvatar({
  name,
  email,
  imageUrl,
  alt,
  size = 40,
  className,
}: ProfileAvatarProps) {
  const initials = getInitials(name, email);
  const sizeStyle = { width: size, height: size };
  const [imageLoadFailed, setImageLoadFailed] = useState(false);
  const shouldShowImage = Boolean(imageUrl) && !imageLoadFailed;

  useEffect(() => {
    setImageLoadFailed(false);
  }, [imageUrl]);

  return (
    <Avatar className={className} style={sizeStyle} aria-label={alt}>
      {shouldShowImage ? (
        <AvatarImage
          src={imageUrl ?? undefined}
          alt={alt}
          onError={() => {
            setImageLoadFailed(true);
          }}
        />
      ) : (
        <AvatarFallback>{initials}</AvatarFallback>
      )}
    </Avatar>
  );
}
